module.exports = __webpack_public_path__ + "img/base_nature_route.d0f00b2d.svg";